import { FC } from "react";
import { CommonInput, HintTooltip, INPUT_TYPES } from "@brg/ui";
import {
    FieldWrapper,
    FieldLabelRow,
    FieldLabelLeft,
    FieldLabelText,
    HintIcon,
    RequiredStar,
} from "../styles";

interface SelectOption {
    label: string;
    value: any;
}

interface SelectFieldProps {
    label: string;
    required?: boolean;
    tooltipText?: string;
    options: SelectOption[];
    value: SelectOption | null;
    placeholder?: string;
    onChange: (opt: SelectOption | null) => void;
}

export const SelectField: FC<SelectFieldProps> = ({
    label,
    required,
    tooltipText,
    options,
    value,
    placeholder,
    onChange,
}) => {
    return (
        <FieldWrapper>
            <FieldLabelRow>
                <FieldLabelLeft>
                    <FieldLabelText>{label}{required && <RequiredStar>*</RequiredStar>}</FieldLabelText>
                    {tooltipText && (
                        <HintTooltip noArrow activeOnMobile positionY="top" text={tooltipText} onWhiteBg>
                            <HintIcon>?</HintIcon>
                        </HintTooltip>
                    )}
                </FieldLabelLeft>
            </FieldLabelRow>
            <CommonInput
                orientation="column"
                type={INPUT_TYPES.dropdown}
                options={options as any}
                value={value as any}
                placeholder={placeholder}
                onWhiteBG
                onChange={onChange as any}
            />
        </FieldWrapper>
    );
};
import { FC } from "react";
import { CommonInput, HintTooltip, INPUT_TYPES } from "@brg/ui";
import {
    FieldWrapper,
    FieldLabelRow,
    FieldLabelLeft,
    FieldLabelText,
    HintIcon,
    RequiredStar,
} from "../styles";

interface SelectOption {
    label: string;
    value: any;
}

interface SelectFieldProps {
    label: string;
    required?: boolean;
    tooltipText?: string;
    options: SelectOption[];
    value: SelectOption | null;
    placeholder?: string;
    onChange: (opt: SelectOption | null) => void;
}

export const SelectField: FC<SelectFieldProps> = ({
    label,
    required,
    tooltipText,
    options,
    value,
    placeholder,
    onChange,
}) => {
    return (
        <FieldWrapper>
            <FieldLabelRow>
                <FieldLabelLeft>
                    <FieldLabelText>{label}{required && <RequiredStar>*</RequiredStar>}</FieldLabelText>
                    {tooltipText && (
                        <HintTooltip noArrow activeOnMobile positionY="top" text={tooltipText} onWhiteBg>
                            <HintIcon>?</HintIcon>
                        </HintTooltip>
                    )}
                </FieldLabelLeft>
            </FieldLabelRow>
            <CommonInput
                orientation="column"
                type={INPUT_TYPES.dropdown}
                options={options as any}
                value={value as any}
                placeholder={placeholder}
                onWhiteBG
                onChange={onChange as any}
            />
        </FieldWrapper>
    );
};
